import { render, staticRenderFns } from "./TrendingPoliticians.vue?vue&type=template&id=3a07ee6f&scoped=true"
import script from "./TrendingPoliticians.vue?vue&type=script&lang=js"
export * from "./TrendingPoliticians.vue?vue&type=script&lang=js"
import style0 from "./TrendingPoliticians.vue?vue&type=style&index=0&id=3a07ee6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a07ee6f",
  null
  
)

export default component.exports